import { BtnClose } from './Button';
import Modal from './Modal';
import { Tit } from './Titles';
import { breakpoint } from '@/helpers/BreakpointHelper';
import React, { FC } from 'react';
import styled from 'styled-components';

export interface ModalProps {
  isOpen?: boolean;
  // 모달 바깥쪽 누를시 닫을수 있는지 여부
  dismissable?: boolean;
  // 닫힘요청시 콜백
  onRequestClose: () => void;
  maxWidth?: string;
}

interface GreetingLayerProps extends ModalProps {
  PopSid: string | number;
  PopTitle: string;
}

const resumeData1 = [
  {
    label: `경력`,
    data: [
      {
        id: 0,
        year: `2021-현재`,
        dec: `유니세프한국위원회 회장`,
      },
      {
        id: 1,
        year: `2020-현재`,
        dec: `㈜ 대한항공 이사회 의장`,
      },
      {
        id: 2,
        year: `2016-현재`,
        dec: `연세대학교 명예특임교수`,
      },
      {
        id: 3,
        year: `1996-현재`,
        dec: `Global Economic Review (영국 Routledge), Editor`,
      },
      {
        id: 4,
        year: `2014-2015`,
        dec: `감사원 감사혁신위원회 위원장`,
      },
      {
        id: 5,
        year: `2013-2015`,
        dec: `국민경제자문회의 거시금융분과 위원장`,
      },
      {
        id: 6,
        year: `2012-2016`,
        dec: `제 17대 연세대학교 총장`,
      },
      {
        id: 7,
        year: `2008-2009`,
        dec: `삼성경제연구소 석좌 연구위원`,
      },
      {
        id: 8,
        year: `2004-2006`,
        dec: `연세대학교 교무처장`,
      },
      {
        id: 9,
        year: `2001-2005`,
        dec: `동북아 경제학회 부회장, 회장`,
      },
      {
        id: 10,
        year: `1986-2016`,
        dec: `연세대학교 상경대학 경제학과 조교수, 부교수, 교수`,
      },
    ],
  },
  {
    label: `학력`,
    data: [
      {
        id: 0,
        year: `1975`,
        dec: `연세대학교 경제학 학사`,
      },
      {
        id: 1,
        year: `1981`,
        dec: `펜실베니아대학교 경제학 석사`,
      },
      {
        id: 2,
        year: `1985`,
        dec: `코넬대학교 경제학 박사`,
      },
      {
        id: 3,
        year: `2014`,
        dec: `게이오대학교 명예 경제학 박사`,
      },
      {
        id: 4,
        year: `2015`,
        dec: `고려대학교 명예 교육학 박사`,
      },
    ],
  },
  {
    label: `상훈`,
    data: [
      {
        id: 0,
        year: `2016`,
        dec: `청조근정 훈장`,
      },
      {
        id: 1,
        year: `2015`,
        dec: `자랑스런 한국인상 (언론인연합회)`,
      },
      {
        id: 2,
        year: `2011`,
        dec: `다산 경제학상 (한국경제신문)`,
      },
      {
        id: 3,
        year: `1993`,
        dec: `매경 이코노미스트 상 (매일경제)`,
      },
    ],
  },
  {
    label: `주요저서`,
    data: [
      {
        id: 0,
        year: `2019`,
        dec: `한국경제, 혼돈의 성찰(공저) (21세기 북스)`,
      },
      {
        id: 1,
        year: `2017`,
        dec: `정갑영의 첫 경제학 (박영사)`,
      },
      {
        id: 2,
        year: `2016`,
        dec: `대학교육의 혁신 (21세기 북스)`,
      },
      {
        id: 3,
        year: `2016`,
        dec: `산업조직론 (박영사)`,
      },
      {
        id: 4,
        year: `2012`,
        dec: `위기의 경제학 (21세기 북스)`,
      },
      {
        id: 5,
        year: `2010`,
        dec: `정갑영의 만화로 읽는 경제학 1,2,3권 (21세기 북스)`,
      },
      {
        id: 6,
        year: `2009`,
        dec: `제3의 자본(공저) (삼성경제연구소)`,
      },
    ],
  },
];
const resumeData2 = [
  {
    label: `경력`,
    data: [
      {
        id: 0,
        year: `2023-현재`,
        dec: `유니세프한국위원회 사무총장`,
      },
      {
        id: 1,
        year: `2021-현재`,
        dec: `세종문화회관 이사장`,
      },
      {
        id: 2,
        year: `2020-현재`,
        dec: `SK바이오 사이언스 사외이사 및 HR위원회 위원장`,
      },
      {
        id: 3,
        year: `2019-현재`,
        dec: `퓨처캡티바리더십그룹 대표`,
      },
      {
        id: 4,
        year: `2014-2018`,
        dec: `현대자동차그룹 인재개발원 부원장`,
      },
      {
        id: 5,
        year: `2007-2012`,
        dec: `LG디스플레이 HR센터장`,
      },
      {
        id: 6,
        year: `1987-2006`,
        dec: `모토로라 한국· 미국· 중국 인적자원개발 변화관리담당 임원 등 역임`,
      },
    ],
  },
  {
    label: `학력`,
    data: [
      {
        id: 0,
        year: `1987`,
        dec: `인디애나대학 교육공학 석사`,
      },
      {
        id: 1,
        year: `1985`,
        dec: `연세대학교 사회학 학사`,
      },
    ],
  },
  {
    label: `주요저서`,
    data: [
      {
        id: 0,
        year: `2014`,
        dec: `낀 세대 리더의 반란 (알에이치코리아(RHK))`,
      },
      {
        id: 1,
        year: `2002`,
        dec: `그녀에게선 바람소리가 난다 (해냄)`,
      },
    ],
  },
];

const PopupTitle = styled.div`
  border-bottom: 1px solid #1cabe2;
  position: relative;
  padding: 22px 0;

  ${BtnClose} {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);

    &::before,
    &::after {
      background: #1cabe2;
    }
  }
`;
const PopContents = styled.div`
  padding: 32px 16px;

  .tbl-wrap {
    margin-bottom: 64px;
    &:last-child {
      margin-bottom: 0;
    }

    table {
      margin-top: 4px;
      border-left: 0;
      td {
        padding: 12px 0;
        text-align: left;
        border: 0;
        height: auto;
      }
    }
  }
  ${breakpoint(`tablet`)} {
    padding: 32px 0;
  }
`;

const PopCcontainer = styled.div`
  padding: 32px;

  ${breakpoint(`tablet`)} {
    padding: 0 20px;
  }
`;

const GreetingPopup: FC<GreetingLayerProps> = ({
  onRequestClose,
  ...props
}) => {
  const resumeData = props.PopSid === 0 ? resumeData1 : resumeData2;
  return (
    <Modal onRequestClose={onRequestClose} maxWidth="880px" {...props}>
      <PopCcontainer>
        <PopupTitle>
          <h2>
            <Tit
              size="s3"
              color="sky"
              dangerouslySetInnerHTML={{ __html: props.PopTitle }}
            />
          </h2>
          <BtnClose onClick={() => onRequestClose()}>
            <span className="a11y">닫기</span>
          </BtnClose>
        </PopupTitle>
        <PopContents>
          {resumeData.map((row, index) => (
            <div className="tbl-wrap">
              <Tit size="s4">{row.label}</Tit>
              <table key={index}>
                <colgroup>
                  <col
                    css={`
                      width: 185px;
                    `}
                  />
                  <col />
                </colgroup>
                <tbody>
                  {row.data.map((row2, index2) => (
                    <tr key={index2}>
                      <td>{row2.year}</td>
                      <td>{row2.dec}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </PopContents>
      </PopCcontainer>
    </Modal>
  );
};

export default GreetingPopup;
